import { PerfiosConstants } from '../Constants';

export function perfios(state = {}, action) {
    switch (action.type) {
        case PerfiosConstants.POST_NETBANKING_REQUEST:
            return {
                ...state,
                postloading: true
            };
        case PerfiosConstants.POST_NETBANKING_SUCCESS:
            return {
                ...state,
                postloading: false,
                postResult: action.payload
            };
        case PerfiosConstants.POST_NETBANKING_FAILURE:
            return {
                ...state,
                postloading: false,
                postError: action.error
            };
        case PerfiosConstants.POST_UPLOAD_STATEMENT_REQUEST:
            return {
                ...state,
                loading: true
            };
        case PerfiosConstants.POST_UPLOAD_STATEMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                result: action.payload
            };
        case PerfiosConstants.POST_UPLOAD_STATEMENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state
    }
}